//---------------------
// save current items
//---------------------
export default function saveCurrentItems(items) {
  // ----------------------
  // check got item array
  // ----------------------
  if (!Array.isArray(items)) return null
  //--------------------------------------------------
  // create array with specified props for each item
  //--------------------------------------------------
  const original_items = items.map((item) => ({
    name: item.name, // for debug only
    id: item.id ? item.id : null, // character item id if existing
    tally_qty: item.tally_qty,
    player_notes: item.player_notes ?? item.notes,
    worn_location: item.worn_location,
    container: item.container,
    attach_location: item.attach_location,
    armour_location: item.armour_location,
    hp: item.hp,
    pwr_storage: item.pwr_storage,
    pwr_storage_cur: item.pwr_storage_cur,
    held: item.held,
    equipped: item.equipped,
    runes: item.runes,
    non_rune_spells: item.non_rune_spells,
  }))
  return original_items
}
